export const trackVideoPlay = (analytics, video) => {
    const { category = {} } = analytics.page;

    return {
        event: 'video play',
        effect: 'media',
        category: {
            primaryCategory: 'video',
            subCategory: category?.subCategory1,
        },
        attributes: {
            video: {
                videoName: video?.thumbnail?.alt,
                videoType: category?.subCategory1,
                milestone: 'start',
            },
        },
    };
};

export const trackVideoCompleted = (analytics, video) => {
    const { category = {} } = analytics.page;

    return {
        event: 'video complete',
        effect: 'media',
        category: {
            primaryCategory: 'video',
            subCategory: category?.subCategory1,
        },
        attributes: {
            video: {
                videoName: video?.thumbnail?.alt,
                videoType: category?.subCategory1,
                milestone: 'complete',
            },
        },
    };
};
